import React from 'react';
import Badge from '@cloudscape-design/components/badge';

export interface AgentBadgeProps {
  processedBy?: string;
}

const AgentBadge: React.FC<AgentBadgeProps> = ({ processedBy }) => {
  if (processedBy === 'claudeagent') {
    return <Badge color="blue">Claude</Badge>;
  }
  if (processedBy === 'strands') {
    return <Badge color="grey">Strands</Badge>;
  }
  return <>—</>;
};

export default AgentBadge;
